export default __webpack_public_path__ + "static/media/pwd.7368c0e9.svg";